import i18n from '@/utils/i18n';
import React from 'react';
import { APP_MODAL_ROUTES } from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { CheckCaptureContent } from '@/components/payments/check-capture-content';
import { ModalContainer } from '@/components/modal-container';
import { StackScreenProps } from '@react-navigation/stack';
import { useCheckCaptureStore } from '@/stores/check-capture-store';

type Props = StackScreenProps<
  AppModalStackParams,
  APP_MODAL_ROUTES.CheckCapture
>;

export const CheckCaptureScreen: React.FC<Props> = ({ navigation, route }) => {
  const {
    chatUUID,
    currencyCode,
    onUnavailable,
    onUseCheck,
    subtotalInMicros,
  } = route.params;

  const commitCheckSelection = useCheckCaptureStore(
    (s) => s.commitCheckSelection,
  );

  const handleUnavailable = (message: string) => {
    onUnavailable(message);
    navigation.goBack();
  };

  const handleUseCheck = () => {
    commitCheckSelection();
    onUseCheck();
  };

  return (
    <ModalContainer
      navigationHeaderProps={{
        title: i18n.t('check_capture.title'),
      }}
    >
      <CheckCaptureContent
        chatUUID={chatUUID}
        currencyCode={currencyCode}
        onUnavailable={handleUnavailable}
        onUseCheck={handleUseCheck}
        subtotalInMicros={subtotalInMicros}
      />
    </ModalContainer>
  );
};
